/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useEffect, useRef } from 'react';

import { jsx } from '@compiled/react';
import { bind, type UnbindFn } from 'bind-event-listener';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { useThemeObserver } from '@atlaskit/tokens';

import { GLEAN_APP_URL } from './constants';
import { type GleanSearchResultsProps } from './types';

const containerStyles = xcss({
	height: '100%',
	display: 'grid',
	paddingBottom: 'space.400',
});

export const GleanSearchResults = ({ query, testId }: GleanSearchResultsProps) => {
	const elementRef = useRef<HTMLDivElement>(null);
	const { colorMode } = useThemeObserver();

	useEffect(() => {
		if (window && document) {
			const script = document.createElement('script');
			const body = document.getElementsByTagName('body')[0];
			script.src = GLEAN_APP_URL;
			body.appendChild(script);
			const unbind: UnbindFn = bind(script, {
				type: 'load',
				listener: () => {
					if (!elementRef.current) {
						return;
					}

					window.EmbeddedSearch.renderSearchResults(elementRef.current, {
						query,
						disableAnalytics: true,
						themeVariant: colorMode || 'light',
					});
				},
				options: {
					once: true,
				},
			});

			return unbind;
		}
	}, [query, colorMode]);
	return (
		<Box xcss={containerStyles}>
			<div data-testid={testId} ref={elementRef} />
		</Box>
	);
};
